var SCM = SCM || {};
var App = App || {};

(function (iou, $, scmLocalStorage) {
    var instOpenUrlKey = 'instOpenUrlKey_';
    var instOpenUrlNoDOIKey = 'instOpenUrlNoDOIKey_';
    var instOpenUrlBaseUrlKey = 'instOpenUrlBaseUrlKey_';

    iou.replaceOpenUrlPlaceHolders = function ($openUrlPlaceHolderElements, replaceLinkHtml) {
        if (replaceLinkHtml && $openUrlPlaceHolderElements.length) {
            $openUrlPlaceHolderElements.each(function () {
                var $placeholder = $(this);
                var targetId = $placeholder.attr('data-targetId');
                var finalLinkHtml = replaceLinkHtml.replace('{openUrlTargetId}', targetId);
                $placeholder.html(finalLinkHtml);
                $placeholder.parent().show().removeClass('empty-target');
            });
        }
    };

    iou.replaceOpenUrlNonDOIPlaceHolders = function ($openUrlPlaceHoldersNoDOIElements, baseUrl, replaceHtml) {
        if (replaceHtml && $openUrlPlaceHoldersNoDOIElements.length) {
            $openUrlPlaceHoldersNoDOIElements.each(function () {
                var $placeholder = $(this);
                var $target = $placeholder.find('.js-open-url-link');
                if ($target.length) {
                    var targetUrlTemplate = $target.attr('data-href-template');
                    if (targetUrlTemplate && targetUrlTemplate.length) {
                        var targetUrl = targetUrlTemplate.replace('{targetURL}', baseUrl);
                        $target.attr('href', targetUrl);
                        $target.removeAttr('data-href-template');
                        $target.html(replaceHtml);
                        // display the link
                        $placeholder.parent().show().removeClass('empty-target');
                    }
                }
            });
        }
    };

    iou.replaceFindInMyLibraryOpenUrlPlaceHolders = function (baseUrl) {
        if (baseUrl && baseUrl.length) {
            $('.js-openurl-library-link').each(function () {
                $(this).removeClass('hide');
                var href = $(this).attr('href');
                $(this).attr('href', baseUrl + href);
            });
        }
    };

    iou.getAndReplaceOpenUrlPlaceHolders = function ($openUrlPlaceHolderElements, $openUrlPlaceHoldersNoDOIElements) {

        if ($('#openUrlUpdated').length) {
            return;
        }
        $('#ContentColumn').append("<input id='openUrlUpdated' type='hidden' value='true'/>");
        var ajaxUrl = '/ThirdParty/InstitutionOpenUrlTemplate';
        var target = "target='_blank'";
        var imageAlt = 'OpenURL Link';
        // If Sigma is enabled, use the url for the Sigma implementation.
        // Sigma information on Confluence: https://confluence.silverchair.com/display/NTS/Sigma+integration+with+Oxford+Academic
        var $oupSigmaHeader = $('.oup-header.sigma');
        if ($oupSigmaHeader.length) {
            ajaxUrl = '/Accounts/SigmaOpenUrl';
            target = '';
            imageAlt = 'Find in my library';
        }

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            success: function (resultObject) {
                if (!resultObject) {
                    return;
                }

                // json result object properties
                // TargetUrl, DisplayOpenUrlLink, LinkImageSource, LinkImageText, BaseUrl
                var replacelink = '';
                var nonDOIreplaceLink = '';
                if (resultObject.DisplayOpenUrlLink) {
                    if (resultObject.LinkImageSource) {
                        replacelink = " <a class='openInAnotherWindow' " + target + " href='" + resultObject.TargetUrl
                            + "'><img alt='" + imageAlt + "' src='" + resultObject.LinkImageSource + "'/></a> ";
                        nonDOIreplaceLink = "<img alt='" + imageAlt + "' src='" + resultObject.LinkImageSource + "'/>";
                    } else {
                        replacelink = " <a class='openInAnotherWindow' " + target + " href='" + resultObject.TargetUrl + "'> " + resultObject.LinkImageText + ' </a> ';
                        nonDOIreplaceLink = resultObject.LinkImageText;
                    }
                }
                // now loop through each placeholder
                iou.replaceOpenUrlPlaceHolders($openUrlPlaceHolderElements, replacelink);
                iou.replaceOpenUrlNonDOIPlaceHolders($openUrlPlaceHoldersNoDOIElements, resultObject.BaseUrl, nonDOIreplaceLink);
                iou.replaceFindInMyLibraryOpenUrlPlaceHolders(resultObject.BaseUrl);
                // now that we determined replacement link, store it in session storage
                if (scmLocalStorage
                    && window.sessionStorage
                    && window.App.LoginUserInfo
                    && window.App.LoginUserInfo.currentSessionId) {

                    scmLocalStorage.setItem(instOpenUrlKey + window.App.LoginUserInfo.currentSessionId,
                        replacelink,
                        window.sessionStorage);
                    scmLocalStorage.setItem(instOpenUrlNoDOIKey + window.App.LoginUserInfo.currentSessionId,
                        nonDOIreplaceLink,
                        window.sessionStorage);
                    scmLocalStorage.setItem(instOpenUrlBaseUrlKey + window.App.LoginUserInfo.currentSessionId,
                        resultObject.BaseUrl,
                        window.sessionStorage);
                }
            },
            error: function () {
                $('#openUrlUpdated').remove();
            }
        });
    };

    iou.checkAndReplaceOpenUrlPlaceHolders = function () {

        // 1) it depends on App.LoginUserInfo.IsInstLoggedIn value to determine if institution is logged in
        // that object should be initialized and values set at master page level.
        // 2) If institution is logged in and also if there are any instOpenUrlPlaceHolders
        // then do ajax call to get openUrlTemplate for logged in institution

        if (window.App.LoginUserInfo && window.App.LoginUserInfo.isInstLoggedIn > 0) {
            // check if article has any openurl templates wtih dois
            var $openUrlPlaceHolders = $('.inst-open-url-holders');
            // check if article has any openurl templates wtih no dois
            var $openUrlPlaceHoldersNoDOI = $('.js-inst-open-url-holders-nodoi');
            // check for library links
            var $libraryLinks = $('.js-openurl-library-link');
            if ($openUrlPlaceHolders.length || $openUrlPlaceHoldersNoDOI.length || $libraryLinks.length) {
                // now check html5 session storage
                // if value exists get replacementLinkHtml, if not go get
                var storedLink = null;
                if (scmLocalStorage && window.sessionStorage && window.App.LoginUserInfo.currentSessionId) {
                    //if we have one, we should have the other
                    var storedLink = scmLocalStorage.getItem(instOpenUrlKey + window.App.LoginUserInfo.currentSessionId,
                        window.sessionStorage);
                    var storedNoDOILink = scmLocalStorage.getItem(
                        instOpenUrlNoDOIKey + window.App.LoginUserInfo.currentSessionId,
                        window.sessionStorage);
                    var storedUrl = scmLocalStorage.getItem(
                        instOpenUrlBaseUrlKey + window.App.LoginUserInfo.currentSessionId,
                        window.sessionStorage);
                }
                // Need to have all 3 since they are stored together.  If one is gone, should re-fetch them
                if (storedLink && storedNoDOILink && storedUrl) {
                    iou.replaceOpenUrlPlaceHolders($openUrlPlaceHolders, storedLink);
                    iou.replaceOpenUrlNonDOIPlaceHolders($openUrlPlaceHoldersNoDOI, storedUrl, storedNoDOILink);
                } else {
                    iou.getAndReplaceOpenUrlPlaceHolders($openUrlPlaceHolders, $openUrlPlaceHoldersNoDOI);
                }
            }
        }
    };

    iou.init = function () {
        // articleFullText widget will leave placeholders for each openUrl token found in reference sectionxml
        // if an institution logged in, this script will get a urltemplate based institutionOpenUrl settings and 
        // replace these placeholders with template populated with appropriate values
        iou.checkAndReplaceOpenUrlPlaceHolders();
    };
})(SCM.InstitutionOpenUrl = SCM.InstitutionOpenUrl || {}, jQuery, SCM.Utilities.LocalStorage);